/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';
import { cloneState } from '../utils/stateUtils';

const INITSTATE = {
    searchAggregations: {
        aggregations: {},
        globalAggregations: {},
        campgroundsAggregations: {},
        dayUseAggregations: {},
    },
};

export default function search(state = INITSTATE, action) {
    let st = { ...state };

    switch (action.type) {
        case types.GET_SEARCH_ERROR:
            st = cloneState(state);
            st.err = action.err;
            return st;

        case types.GET_SEARCH_FILTER_AGGREGATIONS:
            st = cloneState(state);
            if (action.payload.aggregations) {
                st[action.uiFilterName] = action.payload.aggregations;
            } else {
                st[action.uiFilterName] = {};
            }
            delete st.err;
            return st;

        case types.GET_SEARCH_FILTER_GROUP_AGGREGATIONS:
            st = cloneState(state);
            if (action.aggregations) {
                st[action.groupName] = action.aggregations;
            } else {
                st[action.groupName] = {};
            }
            delete st.err;
            return st;

        default:
            return st;
    }
}
